import { t } from 'ember-intl';
import TioPageTabs from 'tio-common/components/tio/page/tabs';
import { Header, VStack } from 'tio-ui/components/layout';

<template>
  <VStack>
    <Header>{{t "coaching.student_loan_coaches"}}</Header>
    <TioPageTabs as |tabs|>
      <tabs.tab
        @label={{t "coaching.about.tab_title"}}
        @route="authenticated.repaying-student-debt.coaching.index"
      />
      <tabs.tab
        @label={{t "coaching.schedule_time.tab_title"}}
        @route="authenticated.repaying-student-debt.coaching.schedule"
      />
    </TioPageTabs>
    {{outlet}}
  </VStack>
</template>
